import type { FC, ReactNode } from 'react'

import { delay } from '@/lib/ui'
import { STUDIO } from '@/constants/site'
import { ContactForm } from '@/components/contact/contact-form'

export const ContactBody: FC = (): ReactNode => {
    return (
        <section id='enquiry' className='ed-wrap pt-[clamp(56px,8vh,104px)]'>
            <div className='ed-rule' data-reveal='rule' />

            <div className='grid gap-y-[clamp(40px,6vh,72px)] pt-[clamp(40px,6vh,84px)] md:grid-cols-12 md:gap-x-[clamp(20px,3vw,48px)]'>
                <div className='md:col-span-4'>
                    <div className='ed-label mb-[clamp(26px,4vh,46px)]' data-reveal='up'>
                        (02) — The studio
                    </div>

                    <dl className='flex flex-col gap-[clamp(24px,3vw,38px)]'>
                        <div data-reveal='up'>
                            <dt className='ed-mono text-faint'>
                                Email
                            </dt>

                            <dd className='mt-3 text-[clamp(15px,1.4vw,19px)] tracking-[-0.01em]'>
                                <a className='ed-link' href={`mailto:${STUDIO.email}`}>
                                    {STUDIO.email}
                                </a>
                            </dd>
                        </div>

                        <div data-reveal='up' style={delay(0.06)}>
                            <dt className='ed-mono text-faint'>
                                Telephone
                            </dt>

                            <dd className='mt-3 text-[clamp(15px,1.4vw,19px)] tracking-[-0.01em]'>
                                <a className='ed-link' href={`tel:${STUDIO.phone.replace(/\s/g, '')}`}>
                                    {STUDIO.phone}
                                </a>
                            </dd>
                        </div>

                        <div data-reveal='up' style={delay(0.12)}>
                            <dt className='ed-mono text-faint'>
                                Studio
                            </dt>

                            <dd className='mt-3 text-[clamp(15px,1.4vw,19px)] leading-relaxed tracking-[-0.01em] text-foreground'>
                                {STUDIO.address.map((line) => (
                                    <span className='block' key={line}>
                                        {line}
                                    </span>
                                ))}
                            </dd>
                        </div>

                        <div data-reveal='up' style={delay(0.18)}>
                            <dt className='ed-mono text-faint'>
                                Hours
                            </dt>

                            <dd className='ed-body mt-3'>
                                {STUDIO.hours}
                            </dd>
                        </div>

                        <div data-reveal='up' style={delay(0.24)}>
                            <dt className='ed-mono text-faint'>
                                Elsewhere
                            </dt>

                            <dd className='mt-3 flex flex-wrap gap-x-7 gap-y-3 text-[clamp(14px,1.3vw,17px)]'>
                                {STUDIO.socials.map((social) => (
                                    <a
                                        key={social.href}
                                        className='ed-link'
                                        href={social.href}
                                        target='_blank'
                                        rel='noreferrer noopener'
                                    >
                                        {social.label}
                                    </a>
                                ))}
                            </dd>
                        </div>
                    </dl>
                </div>

                <div className='md:col-span-7 md:col-start-6'>
                    <div className='ed-label mb-[clamp(26px,4vh,46px)]' data-reveal='up'>
                        (03) — Enquiry
                    </div>

                    <ContactForm />
                </div>
            </div>
        </section>
    )
}
